import { useApi } from 'api/api-context';
import { DataSelect, DataSelectInheritedProps } from 'components/selects/DataSelect';
import { useCallback } from 'react';

interface HrPersonSelectOption {
  value: number;
  label: string;
  group?: string;
}

/** Authoritative permission-scoped HR person selector. */
export default function HrPersonSelect(props: DataSelectInheritedProps) {
  const { getAction } = useApi();
  const fetchPeople = useCallback(async (): Promise<HrPersonSelectOption[]> => {
    const people = await getAction('HrListPeople')({ query: { filters: { includeInactive: true } } });
    return people.map((person) => ({
      value: person.personId,
      label: `${person.firstName} ${person.lastName}`.trim(),
      group: person.organizationName,
    }));
  }, [getAction]);

  return <DataSelect action={fetchPeople} valueProp="value" labelProp="label" groupProp="group" {...props} />;
}
